<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <ValidationProvider
          name="name"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Naam</label>
            <md-input v-model="name" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="order"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Volgorde</label>
            <md-select
              v-model="order"
              name="order"
              id="order"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(orderOption, index) in [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12
                ]"
                :value="orderOption"
                :key="index"
                >{{ orderOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="groupId"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Groep</label>
            <md-select
              v-model="groupId"
              name="groupId"
              id="groupId"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(groupOption, index) in groups"
                :value="groupOption.id"
                :key="index"
                >{{ groupOption.name }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
        <ValidationProvider
          name="typeId"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Type</label>
            <md-select
              v-model="typeId"
              name="typeId"
              id="typeId"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(typeOption, index) in types"
                :value="typeOption.id"
                :key="index"
                >{{ typeOption.label }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      name: "",
      order: "",
      typeId: "",
      groupId: "",
      types: [],
      groups: [],
      touched: {
        name: false,
        order: false,
        typeId: false,
        groupId: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      this.loadUserFieldTypes();
      this.loadUserFieldGroups();
      if (this.$route.params.id !== undefined) {
        this.loadUserField(this.$route.params.id);
      } else {
        this.name = "";
        this.order = "";
        this.typeId = "";
        this.groupId = "";

        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            "users/fields/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            name: this.name,
            order: this.order,
            type_id: this.typeId,
            group_id: this.groupId
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Gebruikers veld succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadUserField(id) {
      this.requesting = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            (this.isDriverField ? "drivers/fields/" : "users/fields/") +
            id
        )
        .then(
          response => {
            this.name = response.data.field.name;
            this.order = response.data.field.order;
            this.typeId = response.data.field.type_id;
            this.groupId = response.data.field.group_id;

            setTimeout(this.resetTouched, 100);

            this.requesting = false;
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    loadUserFieldTypes() {
      this.$http.get(this.$apiBaseUrl + "users/field/types/").then(
        response => {
          this.types = this.sortCollection(
            response.data.fieldTypes,
            "label",
            "asc"
          );
        },
        response => {}
      );
    },
    loadUserFieldGroups() {
      this.$http.get(this.$apiBaseUrl + "users/field/groups/").then(
        response => {
          let data = response.data.fieldGroups;
          for (let i in data) {
            data[i].usertype = ["user"];
          }

          this.loadDriverFieldGroups(data);
        },
        response => {
          this.loadDriverFieldGroups([]);
        }
      );
    },
    loadDriverFieldGroups(data) {
      this.$http.get(this.$apiBaseUrl + "drivers/field/groups/").then(
        response => {
          for (let i in response.data.fieldGroups) {
            if (
              this.getIndexTableDataOfGroup(
                response.data.fieldGroups[i].id,
                data
              )
            ) {
              data[
                this.getIndexTableDataOfGroup(
                  response.data.fieldGroups[i].id,
                  data
                )
              ].usertype.push("driver");
            } else {
              response.data.fieldGroups[i].usertype = ["driver"];
              data.push(response.data.fieldGroups[i]);
            }
          }

          this.groups = data;
        },
        response => {
          this.groups = data;
          this.groups = data;
        }
      );
    },
    getIndexTableDataOfGroup(groupId, data) {
      if (data === null) {
        data = this.tableData;
      }
      for (let i in data) {
        if (data[i].id === groupId) {
          return i;
        }
      }

      return false;
    },
    resetTouched() {
      this.touched.name = false;
      this.touched.order = false;
      this.touched.typeId = false;
      this.touched.groupId = false;
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    name() {
      if (!this.requesting) {
        this.touched.name = true;
      }
    },
    order() {
      if (!this.requesting) {
        this.touched.order = true;
      }
    },
    typeId() {
      if (!this.requesting) {
        this.touched.typeId = true;
      }
    },
    groupId() {
      if (!this.requesting) {
        this.touched.groupId = true;
      }
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    isDriverField: function() {
      if (this.$route.fullPath.indexOf("driver_field_groups") >= 0) {
        return true;
      }
      return false;
    },
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Gebruikers veld bewerken";
      }
      return "Gebruikers veld toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "edit_square";
      }
      return "edit_square";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
